declare global {
   interface Window {
      Appcues: any;
      AppcuesSettings: any;
   }
}
export default defineNuxtPlugin((nuxtApp) => {
   // Initialize Appcues settings on the client
   window.AppcuesSettings = { enableURLDetection: true };

   nuxtApp.hook("page:finish", () => {
      window?.Appcues?.page();
   });
});
